"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getAssets;
const client_1 = __importDefault(require("../../client/client"));
function getAssets(config) {
    return client_1.default.get(config["API_URL"], "/assets");
}
